





















































import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

// Mixins
import IndoorDisplayMixin from './IndoorDisplayMixin.vue'

@Component({
  components: {},
})
export default class IndoorDisplay extends mixins(IndoorDisplayMixin) {}
